import {
    Box,
    Typography
} from "@mui/material";

import { InspectionFailedChip } from "./chips/InspectionFailedChip";
import { InspectionMissingChip } from "./chips/InspectionMissingChip";
import { InspectionPassedChip } from "./chips/InspectionPassedChip";
import { ResolvedIssueChip } from "./chips/ResolvedIssueChip";
import { UnresolvedIssueChip } from "./chips/UnresolvedIssueChip";
import { useDashboardFilter } from "./DashboardFilterContext";

export const Legends = () => {
    const { toggleFilter, filter: {
        showFailed,
        showMissing,
        showNumberOfResolvedIssues,
        showNumberOfUnresolvedIssues,
        showPassed
    } } = useDashboardFilter();

    return (
        <Box className="no-print" display="flex" alignItems="center" gap={1} flexWrap="wrap" ml="auto">
            <Typography variant="caption">Legend:</Typography>
            <Box display="flex" gap={1} alignItems="center" flexWrap="wrap">
                <Box display="flex" gap={0.5} alignItems="center">
                    <Box flex={0.5}>
                        <InspectionPassedChip onClick={() => toggleFilter("showPassed")} isDeactivated={!showPassed} />
                    </Box>
                    <Typography variant="caption" whiteSpace="nowrap" flex={1}>Inspection Passed</Typography>
                </Box>
                <Box display="flex" gap={0.5} alignItems="center">
                    <Box flex={0.5}>
                        <InspectionFailedChip onClick={() => toggleFilter("showFailed")} isDeactivated={!showFailed} />
                    </Box>
                    <Typography variant="caption" whiteSpace="nowrap" flex={1}>Inspection Failed</Typography>
                </Box>
                <Box display="flex" gap={0.5} alignItems="center">
                    <Box flex={0.5}>
                        <InspectionMissingChip onClick={() => toggleFilter("showMissing")} isDeactivated={!showMissing} />
                    </Box>
                    <Typography variant="caption" whiteSpace="nowrap" flex={1}>Inspection Missing</Typography>
                </Box>
                <Box display="flex" gap={0.5} alignItems="center">
                    <Box flex={0.5}>
                        <UnresolvedIssueChip onClick={() => toggleFilter("showNumberOfUnresolvedIssues")} isDeactivated={!showNumberOfUnresolvedIssues} />
                    </Box>
                    <Typography variant="caption" whiteSpace="nowrap" flex={1}># of Issues Present</Typography>
                </Box>
                <Box display="flex" gap={0.5} alignItems="center">
                    <Box flex={0.5}>
                        <ResolvedIssueChip onClick={() => toggleFilter("showNumberOfResolvedIssues")} isDeactivated={!showNumberOfResolvedIssues} />
                    </Box>
                    <Typography variant="caption" whiteSpace="nowrap" flex={1}># of Issues Fixed</Typography>
                </Box>
            </Box>
        </Box>
    );
};
